import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { UserRole } from '@apleona/shared';
import { useAuth } from '../auth';
import { ApleonaLogo } from './ui';

interface Item {
  to: string;
  label: string;
  icon: string;
  adminOnly?: boolean;
}

const GROUPS: { title: string; items: Item[] }[] = [
  {
    title: 'Übersicht',
    items: [{ to: '/', label: 'Dashboard', icon: '▤' }],
  },
  {
    title: 'Vorgänge',
    items: [
      { to: '/protokolle', label: 'Protokolle', icon: '▦' },
      { to: '/pool', label: 'Poolfahrzeuge', icon: '⇄' },
    ],
  },
  {
    title: 'Stammdaten',
    items: [
      { to: '/fahrzeuge', label: 'Fahrzeuge', icon: '▣' },
      { to: '/personen', label: 'Personen', icon: '☺' },
      { to: '/verteiler', label: 'E-Mail-Verteiler', icon: '✉' },
      { to: '/benutzer', label: 'Benutzer', icon: '⚿', adminOnly: true },
    ],
  },
];

const TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/protokolle': 'Protokolle',
  '/pool': 'Poolfahrzeuge',
  '/fahrzeuge': 'Fahrzeuge',
  '/personen': 'Personen',
  '/verteiler': 'E-Mail-Verteiler',
  '/benutzer': 'Benutzer',
};

export const Layout: React.FC = () => {
  const { profile, logout } = useAuth();
  const { pathname } = useLocation();
  const isAdmin = profile?.role === UserRole.ADMIN;

  const title =
    TITLES[pathname] ??
    (pathname.startsWith('/protokolle/')
      ? 'Protokoll'
      : pathname.startsWith('/fahrzeuge/')
        ? 'Fahrzeug'
        : 'Apleona Fuhrpark');

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <ApleonaLogo color="#ffffff" />
          <div className="sub">Fuhrpark-Portal</div>
        </div>
        <nav>
          {GROUPS.map((g) => (
            <React.Fragment key={g.title}>
              <div className="group">{g.title}</div>
              {g.items
                .filter((i) => !i.adminOnly || isAdmin)
                .map((i) => (
                  <NavLink key={i.to} to={i.to} end={i.to === '/'}>
                    <span className="ico">{i.icon}</span>
                    {i.label}
                  </NavLink>
                ))}
            </React.Fragment>
          ))}
        </nav>
        <div className="sidebar-foot">
          <div className="who">{profile?.fullName}</div>
          <div>{profile?.roleLabel}</div>
          {profile?.location ? <div>{profile.location.name}</div> : null}
          <button onClick={logout}>Abmelden</button>
        </div>
      </aside>

      <div className="main">
        <header className="topbar">
          <div>
            <div className="crumb">Apleona Fuhrpark</div>
            <h1>{title}</h1>
          </div>
        </header>
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
